import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "panel"
}
const _hoisted_2 = { class: "form-group" }
const _hoisted_3 = {
  key: 0,
  class: "dynamic-list"
}
const _hoisted_4 = { value: "" }
const _hoisted_5 = ["value"]

import { computed, onMounted, ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { useStore } from 'vuex';
import { AppStore } from '@/store';
import { ErrorBag } from '@/core/common';
import { getAllLanguages, Language } from '@/modules/parameters/Language';
import { CustomerSubscription } from '@/modules/customer/CustomerSubscription';
import { Product } from '@/modules/product/Product';
import FaIcon from '@/core/components/FaIcon.vue';
import AppButton from '@/core/components/form/AppButton.vue';
import AppModal from '@/core/components/AppModal.vue';
import AppFormGroup from '@/core/components/form/AppFormGroup.vue';
import AppSelect from '@/core/components/form/AppSelect.vue';

interface CustomerFormLanguagesProps {
	languages: string[];
	subscriptions: CustomerSubscription[];
	errors: ErrorBag;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerFormLanguages',
  props: {
    languages: {},
    subscriptions: {},
    errors: {}
  },
  emits: [
	'languageAdded',
	'languageRemoved',
],
  setup(__props: any, { emit: __emit }) {

const { $gettext } = useGettext();
const store = useStore<AppStore>();
const props = __props;
const emit = __emit;

const countAllowedLanguages = computed<number>(() => {
	return props.subscriptions
		.filter((cs: CustomerSubscription) => {
			const product = store.getters.productAddons.find((p: Product) => p.id === cs.product.id);
			if (!product) {
				return false;
			}

			return (product.code && product.code === 'EXTRA_LANGUAGE')
		})
		.length
	;
});
const allLanguages = ref<Language[]>([]);
const selectedLanguagesWithName = computed<Language[]>(() => allLanguages.value
	.filter((l: Language) => props.languages.indexOf(l.id) >= 0),
);
const addLanguageOpen = ref<boolean>(false);
const selectedAddLanguage = ref<string>('');

onMounted(async () => {
	await store.dispatch('loadProducts');
	allLanguages.value = await getAllLanguages();
});

const openAddLanguage = () => (addLanguageOpen.value = true);
const closeAddLanguage = () => (addLanguageOpen.value = false);

const addLanguage = () => {
	if (!selectedAddLanguage.value) {
		return;
	}

	const language = allLanguages.value.find(langId => langId.id === selectedAddLanguage.value);

	if (!language) {
		return;
	}

	emit('languageAdded', selectedAddLanguage.value);

	selectedAddLanguage.value = '';
	closeAddLanguage();
};

const removeLanguage = (languageId: string) => {
	emit('languageRemoved', languageId);
};

return (_ctx: any,_cache: any) => {
  const _component_translate = _resolveComponent("translate")!
  const _directive_translate = _resolveDirective("translate")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (countAllowedLanguages.value > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _withDirectives((_openBlock(), _createElementBlock("h2", null, [...(_cache[1] || (_cache[1] = [
            _createTextVNode("Språk", -1)
          ]))])), [
            [_directive_translate]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.errors.language, (error, i) => {
            return (_openBlock(), _createElementBlock("span", {
              key: i,
              class: "form-error"
            }, _toDisplayString(error), 1))
          }), 128)),
          _createElementVNode("div", _hoisted_2, [
            (__props.languages.length)
              ? (_openBlock(), _createElementBlock("ul", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLanguagesWithName.value, (language) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: language.id
                    }, [
                      _createTextVNode(_toDisplayString(language.name) + " ", 1),
                      _createVNode(AppButton, {
                        onClick: _withModifiers(($event: any) => (removeLanguage(language.id)), ["prevent"]),
                        class: "t-danger",
                        seamless: ""
                      }, {
                        default: _withCtx(() => [
                          _createVNode(FaIcon, {
                            weight: "s",
                            icon: "trash-alt"
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _createVNode(AppButton, {
              onClick: _withModifiers(openAddLanguage, ["prevent"])
            }, {
              default: _withCtx(() => [
                _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Lägg till", -1)
                ]))])), [
                  [_directive_translate]
                ])
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true),
    (addLanguageOpen.value)
      ? (_openBlock(), _createBlock(AppModal, {
          key: 1,
          onClose: closeAddLanguage,
          footer: false
        }, {
          header: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("h1", null, [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Lägg till språk", -1)
            ]))])), [
              [_directive_translate]
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _withModifiers(addLanguage, ["prevent"])
            }, [
              _createVNode(AppFormGroup, {
                id: "customer_language_add",
                label: _unref($gettext)('Språk')
              }, {
                default: _withCtx(() => [
                  _createVNode(AppSelect, {
                    id: "customer_language_add",
                    modelValue: selectedAddLanguage.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedAddLanguage).value = $event)),
                    required: ""
                  }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createElementBlock("option", _hoisted_4, [...(_cache[4] || (_cache[4] = [
                        _createTextVNode("Välj", -1)
                      ]))])), [
                        [_directive_translate]
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allLanguages.value, (language) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: language.id,
                          value: language.id
                        }, _toDisplayString(language.name), 9, _hoisted_5))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createElementVNode("p", null, [
                _createVNode(AppButton, { type: "submit" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createTextVNode("OK", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(AppButton, {
                  onClick: closeAddLanguage,
                  class: "t-neutral"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_translate, null, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("Avbryt", -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ], 32)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})